export const serviceNavigationIreland = {
  postcode_in_sentence: 'Eircode',
  postcode_option_title: 'Eircode',
  postcode_option_subtitle: 'Enter an Eircode to search an area',
  enter_postcode: 'Enter an Eircode',
  find_location_postcode: 'Find a location by entering an Eircode',
}
